<div class="setpoint-bars" [class.responsive]="screenAdjust">

  @if (days) {
    <div class="bars" [style.width.px]="barWidth">
      @for (day of days; track day; let i = $index) {
        <div class="bar day-{{i}}" (mouseenter)="mouseenter(i)" (mouseleave)="mouseleave()"
          [class.green]="day?.maxAlert===0 && day?.minAlert===0 && day?.minOrangeAlert=== 0 && day?.maxOrangeAlert===0"
          [class.orange]="day?.maxOrangeAlert>0 || day?.minOrangeAlert>0" [class.red]="day?.maxAlert>0 || day?.minAlert>0"
          (click)="hasClicked(i)">
        </div>
      }
    </div>
  }

  <div class="info">
    <div class="details">
      @if (hoverDay && hoverDay.date) {
        <span>{{hoverDay.date}} min:<span>{{hoverDay.min}}</span> max:<span>{{hoverDay.max}}</span></span>
      }
    </div>
  </div>

</div>